import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import moment from 'moment';

import BackButton from '../BackButton';
import EmailMessageInput from '../EmailMessageInput';
import SurveyScheduling from '../SurveyScheduling';
import { LONG_DISPLAY_DATE_FORMAT, surveyFieldIds } from '../../constants';
import withValidation from '../WithValidation';
import { rescheduleSurveyPageValidator } from '../../validators/surveys';
import {
  clearSurveyAction,
  getSurveyScheduleAction,
  sendNotificationAction,
  updateSurveyOptionsAction,
  updateSurveyScheduleAction
} from '../../actions';
import { surveyOptionsType } from '../../constants/types';
import withRouter from '../WithRouter';
import { withLang, langType } from '../../i18n';

import sharedStyles from '../../styles/shared';
import { setDocumentTitle } from '../../util';

class RescheduleSurveyView extends Component {
  constructor(props) {
    super(props);

    this.submit = this.submit.bind(this);

    this.state = {
      isSubmitted: false,
      isLoading: true
    };
  }

  componentDidMount() {
    const { dispatchGetSurveySchedule, dispatchUpdate, params } = this.props;
    dispatchGetSurveySchedule(params.surveyId)
      .then(({ value }) => {
        dispatchUpdate({ startDate: value.startDate, endDate: value.endDate });
        this.setState({ isLoading: false });
      });
  }

  componentWillUnmount() {
    this.props.dispatchClear();
  }

  submit(event) {
    event.preventDefault();

    const {
      surveyOptions, dispatchUpdateSurveySchedule,
      dispatchSendNotification, params
    } = this.props;
    const { surveyId } = params;
    const { endDate, reminderEmailTitle, reminderEmailContent } = surveyOptions;

    dispatchUpdateSurveySchedule(surveyId, { endDate })
      .then(({ value }) => {
        if (value.endDate) {
          dispatchSendNotification(surveyId, reminderEmailTitle, reminderEmailContent)
            .then(() => this.setState({ isSubmitted: true }));
        }
      });
  }

  render() {
    const {
      hasInvalidField, isValid, surveyOptions, translate: t
    } = this.props;
    const { isLoading, isSubmitted } = this.state;
    setDocumentTitle(t('manageSurveys.scheduling.title'));

    return !isLoading ? (
      <div className="page-container">
        <BackButton />
        {(!isSubmitted
        && (
        <form>
          <div>
            <h2 className="panel__title">{t('manageSurveys.scheduling.title')}</h2>
          </div>
          <SurveyScheduling
            showStartDate={false}
            initialEndDate={surveyOptions.endDate}
            showProblems
          />
          <div>
            <p>{t('manageSurveys.scheduling.reminderMessageInfo')}</p>
          </div>
          <EmailMessageInput
            messageTitleName={surveyFieldIds.REMINDER_TITLE}
            messageContentName={surveyFieldIds.REMINDER_CONTENT}
            hasInvalidField={hasInvalidField}
            dataCyPrefix="survey-reminder-email"
          />
          <button
            type="submit"
            disabled={!isValid}
            className={`button ${sharedStyles.submitButton}`}
            onClick={this.submit}
            data-cy="save-and-send-button"
          >
            {t('manageSurveys.scheduling.saveAndSendMessage')}
          </button>
        </form>
        )
        )
        || (
        <h2 className="panel__title"><Translate
          id="manageSurveys.scheduling.surveyRescheduledAndReminderSent"
          data={{ endDate: moment(surveyOptions.endDate).format(LONG_DISPLAY_DATE_FORMAT) }}
        />
        </h2>
        )}
      </div>
    ) : null;
  }
}

const {
  func, string, shape, bool
} = PropTypes;

RescheduleSurveyView.propTypes = {
  surveyOptions: surveyOptionsType.isRequired,
  params: shape({
    surveyId: string
  }).isRequired,
  hasInvalidField: func.isRequired,
  isValid: bool.isRequired,
  dispatchGetSurveySchedule: func.isRequired,
  dispatchUpdate: func.isRequired,
  dispatchClear: func.isRequired,
  dispatchUpdateSurveySchedule: func.isRequired,
  dispatchSendNotification: func.isRequired,
  translate: langType.translate.isRequired
};

const mapStateToProps = ({ survey }) => ({
  surveyOptions: survey.surveyOptions
});

const mapDispatchToProps = (dispatch) => ({
  dispatchGetSurveySchedule: (surveyId) =>
    dispatch(getSurveyScheduleAction(surveyId)),
  dispatchUpdate: (surveyOptions) =>
    dispatch(updateSurveyOptionsAction(surveyOptions)),
  dispatchClear: () =>
    dispatch(clearSurveyAction()),
  dispatchUpdateSurveySchedule: (surveyId, data) =>
    dispatch(updateSurveyScheduleAction(surveyId, data)),
  dispatchSendNotification: (surveyId, title, message) =>
    dispatch(sendNotificationAction(surveyId, title, message))
});

export default withRouter(connect(mapStateToProps,
  mapDispatchToProps)(withLang(withValidation(RescheduleSurveyView, rescheduleSurveyPageValidator))));
